var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaptopAcerSwift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 28V27.5H12.5V28H11ZM7.5 28V12C7.5 11.5 7.75 11 8.5 11H31.5C32.25 11 32.5 11.5 32.5 12V28H36V29.1006C36 29.2106 35.9283 29.3075 35.8261 29.3482C35.7301 29.3864 35.6222 29.4337 35.5047 29.4853C35.0048 29.7044 34.3305 30 33.6562 30H6.34375C5.66948 30 4.99521 29.7044 4.49533 29.4853L4.49521 29.4852L4.49516 29.4852C4.37767 29.4337 4.26982 29.3864 4.17387 29.3482C4.07168 29.3075 4 29.2106 4 29.1006V28H7.5ZM7.5 28.5H4.5V28.9C4.5 28.9 5.5 29 6 29H34C34.5 29 35.5 28.9 35.5 28.9V28.5H32.5H29H27.5H12.5H11H7.5ZM27.5 28H29V27.5H27.5V28ZM13 27V27.5H27V27H29.5V27.5H31.5V12H8.5L8.5 27.5H10.5V27H13ZM30.5 25H9.5V13.5H30.5V25ZM9 26V13H31V26H9Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopAcerSwift);
export default __webpack_public_path__ + "static/media/laptop-acer-swift.2a6ef7a2bea5b2fe26748cecd268020d.svg";
export { ForwardRef as ReactComponent };